import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { guestService } from "@/services/altingross";

// ─── Thunks ─────────────────────────────────────────────────────────────────
export const fetchGuests = createAsyncThunk(
  "guests/fetchList",
  async ({ page = 1, size = 20, field, value, operator } = {}, { rejectWithValue }) => {
    try {
      const res = await guestService.getList({ page, size, field, value, operator });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data ?? err.message);
    }
  }
);

export const getGuestById = createAsyncThunk(
  "guests/getById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await guestService.getById(id);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data ?? err.message);
    }
  }
);

export const deleteGuest = createAsyncThunk(
  "guests/delete",
  async (id, { rejectWithValue }) => {
    try {
      await guestService.deleteById(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data ?? err.message);
    }
  }
);

// ─── Slice ───────────────────────────────────────────────────────────────────
const guestsSlice = createSlice({
  name: "guests",
  initialState: {
    list: [],
    pagination: { page: 1, size: 20, count: 0, totalPages: 1, hasNext: false, hasPrev: false },
    loading: false,
    error: null,
    deletingId: null,
    selectedGuest: null,
    detailLoading: false,
  },
  reducers: {
    clearSelectedGuest: (state) => {
      state.selectedGuest = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // fetchGuests
      .addCase(fetchGuests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGuests.fulfilled, (state, action) => {
        state.loading = false;
        const { items, page, size, count, totalPages, hasNext, hasPrev } = action.payload;
        state.list = items ?? [];
        state.pagination = { page, size, count, totalPages, hasNext, hasPrev };
      })
      .addCase(fetchGuests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // getGuestById
      .addCase(getGuestById.pending, (state) => {
        state.detailLoading = true;
      })
      .addCase(getGuestById.fulfilled, (state, action) => {
        state.detailLoading = false;
        state.selectedGuest = action.payload;
      })
      .addCase(getGuestById.rejected, (state, action) => {
        state.detailLoading = false;
        state.error = action.payload;
      })
      // deleteGuest
      .addCase(deleteGuest.pending, (state, action) => { state.deletingId = action.meta.arg; })
      .addCase(deleteGuest.fulfilled, (state, action) => {
        state.deletingId = null;
        state.list = state.list.filter((g) => g.id !== action.payload);
      })
      .addCase(deleteGuest.rejected, (state) => { state.deletingId = null; });
  },
});

export const { clearSelectedGuest } = guestsSlice.actions;
export default guestsSlice.reducer;
